var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 4.73684C10.8571 6.24836 9.57796 7.47368 8 7.47368C6.42204 7.47368 5.14286 6.24836 5.14286 4.73684C5.14286 3.22533 6.42204 2 8 2C9.57796 2 10.8571 3.22533 10.8571 4.73684Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.2632C13 13.7747 10.7614 15 8 15C5.23858 15 3 13.7747 3 12.2632C3 10.7516 5.23858 9.52632 8 9.52632C10.7614 9.52632 13 10.7516 13 12.2632Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4758ba332862ff330038d500b5e1fc1e.svg";
export { ForwardRef as ReactComponent };